// Fixed coordinates are relative to the visual viewport, including mobile zoom.
export function minisiteMenuPosition(anchor, menuHeight, viewport, rtl = false) {
  const edge = 8;
  const gap = 6;
  const width = Math.min(215, Math.max(1, viewport.width - edge * 2));
  const right = viewport.left + viewport.width - edge;
  const bottom = viewport.top + viewport.height - edge;
  const below = Math.max(0, bottom - anchor.bottom - gap);
  const above = Math.max(0, anchor.top - gap - viewport.top - edge);
  const openAbove = below < menuHeight && above > below;
  const maxHeight = Math.max(1, openAbove ? above : below);
  return {
    left: Math.max(viewport.left + edge, Math.min(rtl ? anchor.left : anchor.right - width, right - width)),
    top: openAbove ? anchor.top - gap - Math.min(menuHeight, maxHeight) : anchor.bottom + gap,
    width,
    maxHeight,
  };
}
